import * as vkbeautify from 'vkbeautify';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'xmlJson'
})
export class XmlPipe implements PipeTransform {

  transform(value: string, type: string): string {
    if (value === null) {
      return "";
    }
    try {
      switch (type) {
        case 'JSON':
          const jsonValue = JSON.parse(value);
          return vkbeautify.json(JSON.stringify(jsonValue), 4);
        case 'XML':
          return vkbeautify.xml(value);
      }
    } catch (error) {
      return value;
    }
  }

}
